import { render, staticRenderFns } from "./dailySummary.vue?vue&type=template&id=2d64bf68&scoped=true&"
import script from "./dailySummary.vue?vue&type=script&lang=js&"
export * from "./dailySummary.vue?vue&type=script&lang=js&"
import style0 from "./dailySummary.vue?vue&type=style&index=0&id=2d64bf68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d64bf68",
  null
  
)

component.options.__file = "dailySummary.vue"
export default component.exports